export const DOC_KEYS = [
  { key: 'identity', label: 'Kimlik / Pasaport', field: 'id_expiry_date' },
  { key: 'license', label: 'Ehliyet', field: 'license_expiry_date' },
  { key: 'attest', label: 'Sürücü Belgesi', field: 'driver_attest_expiry_date' },
];

export const STATE_STYLE = {
  expired: 'bg-red-100 text-red-700 border-red-300 dark:bg-red-900/40 dark:text-red-300 dark:border-red-800',
  soon: 'bg-orange-100 text-orange-700 border-orange-300 dark:bg-orange-900/30 dark:text-orange-300 dark:border-orange-800',
  warn: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800',
  ok: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800',
  missing: 'bg-slate-50 text-slate-400 border-dashed border-slate-300 dark:bg-slate-800 dark:border-slate-600',
};

export const STATUS_TABS = [
  { key: 'active', label: 'Aktif' },
  { key: 'passive', label: 'Pasif' },
  { key: 'left', label: 'İşten Ayrılanlar' },
  { key: 'all', label: 'Tümü' },
];

export const ISSUE_FILTERS = [
  { key: 'all', label: 'Hepsi' },
  { key: 'expired', label: 'Süresi dolan' },
  { key: 'soon', label: '30 gün içinde dolacak' },
  { key: 'missing_docs', label: 'Eksik belge' },
  { key: 'missing_info', label: 'Eksik bilgi' },
  { key: 'complete', label: '%100 tamam' },
];

export const matchesIssue = (r, f) => {
  if (f === 'expired') return r.expiry_alert === 'expired';
  if (f === 'soon') return r.expiry_alert === 'soon';
  if (f === 'missing_docs') return r.missing_docs.length > 0;
  if (f === 'missing_info') return r.missing_fields.length > 0;
  if (f === 'complete') return r.completion === 100;
  return true;
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('tr-TR') : '—');

export const daysText = (d) => {
  if (d === null || d === undefined) return 'tarih yok';
  if (d < 0) return `${Math.abs(d)} gün önce doldu`;
  if (d === 0) return 'bugün doluyor';
  return `${d} gün kaldı`;
};

export const profileUrl = (userId, tab) => `/dashboard/employees/${userId}${tab ? `?tab=${tab}` : ''}`;

export const normalizeTr = (str) => (str || '')
  .replace(/İ/g, 'i').replace(/I/g, 'i').replace(/Ş/g, 's').replace(/Ç/g, 'c').replace(/Ö/g, 'o').replace(/Ü/g, 'u').replace(/Ğ/g, 'g')
  .toLowerCase().replace(/\u0307/g, '').replace(/ş/g, 's').replace(/ç/g, 'c').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ğ/g, 'g').replace(/ı/g, 'i');
